import React from 'react'
import { styled } from 'linaria/react'
import { css } from 'linaria'
import { Cancel } from 'iconoir-react'
import { theme } from '../../Theme'

export const Tag = styled('button')`
   & {
      border-radius: 50px;
      font-size: 1rem;
      line-height: normal;
      display: inline-block;
      padding: 0.15rem 0.5rem 0.15rem 1rem;
      font-family: var(--font-grotesk);
      border: 3px solid var(--color-vb-blue);
      color: var(--color-vb-blue);
      background-color: rgba(25, 81, 120, 0.05);
      transition: background-color 0.5s ease;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      min-height: 1.5rem;
      /* min-height: 41px; */
      /* min-height: 2.5rem; */
   }

   &:hover {
      background-color: rgba(25, 81, 120, 0.2);
      transition: background-color 0.5s ease;
   }

   & span {
      color: var(--color-vb-blue);
      white-space: nowrap;
   }

   .tag-value-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      white-space: nowrap;
   }

   .tag-label {
      font-weight: 600;
      white-space: nowrap;
      font-size: 11px;
      line-height: 11px;
   }

   .tag-value {
      font-size: 1rem;
      white-space: nowrap;
      font-weight: 600;
   }

   /* Lighter, smaller chips on mobile */
   ${theme.below.lg} {
      & {
         border: none;
         padding: 0.35rem 0.75rem;
         background-color: #e6edf3;
         gap: 0.35rem;
      }
      .tag-value {
         font-size: 0.9rem;
         font-weight: 700;
      }
   }
`

const ClearTag = css`
   color: var(--color-red);
   border: 3px solid var(--color-red);
   background-color: rgba(120, 25, 25, 0.05);

   span {
      color: var(--color-red);
   }

   &:hover {
      background-color: rgba(120, 25, 25, 0.2);
      transition: background-color 0.5s ease;
   }

   ${theme.below.lg} {
      border: none;
      background-color: rgba(166, 18, 0, 0.08);
   }
`

const FilterTag = ({ value, isClearTag, onClick }) => {
   return (
      <Tag className={isClearTag && ClearTag} onClick={onClick}>
         <div className="tag-value-container">
            <span className="tag-value">{value}</span>
         </div>
         <Cancel strokeWidth={3.0} height={18} width={18}></Cancel>
      </Tag>
   )
}

export default FilterTag